// extracted by mini-css-extract-plugin
module.exports = {"body":"_app_body__SD3BH","modalContainer":"_app_modalContainer__DKOtn"};